<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="6">

						<el-form-item label="周期">
							<el-select v-model="period" @change="list"  placeholder="请选择">
								<el-option v-for="item in listType" :key="item.id" :label="item.val"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="日期">
							<el-date-picker v-if="searchParams.type=='1'" value-format="yyyy-MM-dd" @change="list" v-model="searchParams.date" type="date" placeholder="选择日期">
							</el-date-picker>
							<el-date-picker v-else-if="searchParams.type=='2'"  v-model="searchParams.date"  @change="list" value-format="yyyy-MM-dd" type="week" format="yyyy 第 WW 周"
								placeholder="选择周">
							</el-date-picker>
							<el-date-picker v-else v-model="searchParams.date" value-format="yyyy-MM" type="month" @change="list"   placeholder="选择月">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<div class="search-btn">
						<el-button type="primary" icon="el-icon-search" @click="list">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>
					</div>
				</el-row>
			</el-form>
		</div>
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto"
				@selection-change="selectionChange" v-loading="listLoading">
				<el-table-column type="selection" width="55" fixed="left"></el-table-column>
				<el-table-column prop="paytm" label="日期"></el-table-column>
				<el-table-column prop="xsstucnt" label="线上课报名数">
				</el-table-column>
				<el-table-column prop="xscosts" label="线上课营收">
					<template slot-scope="scope">
						{{ ( scope.row.xscosts /100).toFixed(2) }}
					</template>
				</el-table-column>
				<el-table-column prop="ststucnt" label="刷题报名数"></el-table-column>
				<el-table-column prop="stcosts" label="刷题营收">
					<template slot-scope="scope">
					{{ ( scope.row.stcosts /100).toFixed(2) }}
				</template>
				</el-table-column>
				<el-table-column prop="paytm" label="总人数">
					<template slot-scope="scope">
						{{ scope.row.xsstucnt+ scope.row.ststucnt }}
					</template>
				</el-table-column>
				<el-table-column prop="paytm" label="总金额">
					<template slot-scope="scope">
						{{ ((scope.row.xscosts+ scope.row.stcosts)/100).toFixed(2)}}
					</template>
				</el-table-column>

			</el-table>
			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>

	</div>
</template>
<script>

import api from '@/api/online/clazz/clazz.js';
export default {
	name: 'tDepartment',
	components: {

	},
	data() {
		return {
			searchParams: { type: '0' },
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			listType: [{id:'1',val:'日报'}, {id:'2',val:'周报'}, {id:'0',val:'月报'}],
			page: new this.$constant.pageObj(),
			period:'1'
		};
	},
	methods: {
		//获取数据
		list() {
			this.listLoading = true;
			this.searchParams.type =this.period;

			  if(this.searchParams.type=='2'){ //按周查询
				 //传进来的是月份，补齐1号
			  	 if(this.searchParams.date && this.searchParams.date.length<8){
					this.searchParams.date = this.searchParams.date+'-01'
				 }
			  }

			let params = this.$utils.merger(this.searchParams, this.page);


			api.listRpt(params, response => {
				this.listData = response.data;
				this.listLoading = false;
			})
		},  

		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.period ='1'
			this.searchParams = {type:this.period};
			this.list()
		}
	},
	mounted() {
		this.list();

	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
